import React from 'react'
import PropTypes from 'prop-types'
import I18n, { Translate } from 'i18n'
import './style.css'


const ItemsClearLink = props => {
    const handleClick = (e) => {
        e.preventDefault()

        if (window.confirm(I18n.t('confirmClearList'))) {
            props.clearItems()
            props.createList()
        }
    }

    return props.isVisible
        ? <a href='/' className='clear-link' onClick={handleClick}><Translate value='clearList' /></a>
        : null
}

ItemsClearLink.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    clearItems: PropTypes.func.isRequired,
    createList: PropTypes.func.isRequired
}

export default ItemsClearLink
